"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteInformationSave = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var CompleteInformationSave = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CompleteInformationSave, _super);
    function CompleteInformationSave() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷补全资料保存接口';
        _this.code = '101119';
        _this.desc = '现金贷补全资料保存接口';
        _this.requestParams = new cashLoanAuth_1.CompleteInformationSaveRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CompleteInformationSave;
}(service_1.BaseService));
exports.CompleteInformationSave = CompleteInformationSave;
//# sourceMappingURL=completeInformationSave.js.map